<template>
  <AppLogo variant="prelogin" />
  <div class="main-content d-flex flex-column transition overflow-hidden p-0">
    <div class="container">
      <InvitationForm />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import InvitationForm from "@/components/FK/UserForm/InvitationForm.vue";
import AppLogo from "@/components/Widgets/AppLogo.vue";

export default defineComponent({
  name: "InvitationPage",
  components: {
    InvitationForm,
    AppLogo
  },
  computed: {
    page_title(): string { return this.$route.query.role_name === undefined ? this.$t('page.create_user') : `${this.$t('cta.create')} ${this.$route.query.role_name}` }
  }
});
</script>